// src/config/componentsMap.js
import UsersPage from "../../pages/panels/UsersPage";
import AdminSetting from "../../pages/panels/AdminSettings";
import EmailCampaignsPage from "../../pages/panels/EmailCampaignPage";
import TicketPage from "../../pages/panels/TicketPage";
import ProductDashboard from "../../pages/panels/Products/CreateProduct";
import FeedbackPage from "../../pages/panels/FeedbackPage";

//import FeedbackPage from "../../pages/panels/FeedbackPage";
import PartnerDashboard from "../../pages/panels/Rag_Panel/PartnerDashboard"; 
import CustomerOutreach from "../../pages/panels/CustomerOutreach";
export const componentsMap = {
  user_management: UsersPage,
  account_settings: AdminSetting,
  tickets: TicketPage,
  campaigns: EmailCampaignsPage,
  create_product:ProductDashboard,
  feedback_management: FeedbackPage,
  partner_dashboard: PartnerDashboard,
  customer_outreach: CustomerOutreach,
//   TemplatesPage,
};
